import { render } from "./footer_default.vue?vue&type=template&id=33a747a0"
import script from "./footer_default.vue?vue&type=script&lang=js"
export * from "./footer_default.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__